module.exports = __webpack_public_path__ + "images/next/recruiting_services/triangle-a65d7568cbad16c13b480c20fd5c24f2.png";